import { Fragment } from 'react';
import { connect } from 'react-redux';

import { AddTileToDigestTile } from './AddTileToDigestTile.jsx';
import { SingleTile } from './SingleTile.jsx';
import { EmptyTile } from './EmptyTile.jsx';

const emptyTilesAmount = (tileCount, tilesPerRow) => {
  const remainder = tileCount % tilesPerRow;

  return remainder !== 0 ? tilesPerRow - remainder : 0;
};

const TileList = ({
  activeFilters,
  activeStatus,
  addTileToDigest,
  canAddTile,
  changeTileStatus,
  handleMenuAction,
  hasEmptyTileFillers,
  isUserSiteAdmin,
  moveTileBackToPlan,
  moveTileToProof,
  tileDigestPlanDate,
  tiles,
  tilesPerRow,
}) => (
  <Fragment>
    {canAddTile && tiles.length === 0 && (
      <AddTileToDigestTile
        onClick={() => addTileToDigest(tileDigestPlanDate, tiles)}
      />
    )}
    {tiles.map((tile, index) => (
      <SingleTile
        key={index}
        tile={tile}
        index={index}
        activeStatus={activeStatus}
        changeTileStatus={changeTileStatus}
        handleMenuAction={handleMenuAction}
        isUserSiteAdmin={isUserSiteAdmin}
        activeFilters={activeFilters}
        moveTileBackToPlan={moveTileBackToPlan}
        moveTileToProof={moveTileToProof}
      />
    ))}
    {hasEmptyTileFillers &&
      [
        ...Array(
          emptyTilesAmount(tiles.length === 0 ? 1 : tiles.length, tilesPerRow),
        ).keys(),
      ].map((item, index) => (
        <EmptyTile key={`empty-${index}`} planDate={tileDigestPlanDate} />
      ))}
  </Fragment>
);

const mapStateToProps = state => ({
  tilesPerRow: state.tilesPerRow,
});

export default connect(mapStateToProps)(TileList);
